<template>
  <div class="container foot-style-two text-sm-left text-center">
    <div
      v-if="default_footer_items_length"
      class="row foot-style-two--items"
      :class="default_footer_items_length > 3 ? 'justify-content-between' : 'justify-content-center'"
    >
      <template v-for="(item, index) in default_footer_items">
        <div
          class="col-12 col-sm-3"
          v-if="(item.type === 'menu' && item.menu) || item.type === 'info'"
          :key="`foot-style-two-${index}`"
        >
          <component :is="`v-common-foot-${item.type}`" :config="item || {}"></component>
        </div>
      </template>
    </div>
    <div class="foot-style-two--bottom">
      <div class="foot-style-two--bottom__left">
        <p><a class="page_text_font" href="/policies/ip">DMCA report</a> ©{{ new Date().getFullYear() }},{{ title }}</p>
        <v-selectlang :langs_meta="langs_meta"></v-selectlang>
      </div>
      <v-payicon v-if="show_payment_icons"></v-payicon>
    </div>
  </div>
</template>
<script>
import vCommonFootMenu from './commonFootMenu.vue'
import vCommonFootInfo from './commonFootInfo.vue'
export default {
  components: {
    vCommonFootMenu,
    vCommonFootInfo,
  },
  props: {
    default_footer_items: {},
    langs: {},
    langs_meta: {},
    enabled: {},
    title: {},
    show_payment_icons: {},
  },
  computed: {
    default_footer_items_length() {
      let onOff = 0
      if (this.default_footer_items && Array.isArray(this.default_footer_items)) {
        this.default_footer_items.forEach((item) => {
          const { type, menu } = item
          if ((type && type === 'menu' && menu) || type === 'info') onOff++
        })
      }
      return onOff
    },
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang='scss'>
p {
  margin: 0;
  padding: 0;
}
.foot-style-two {
  padding-bottom: 40px;
  &--items {
    & > div {
      padding: 0 20px;
    }
    @media screen and (max-width: 767px) {
      & > div:not(:first-child) {
        margin-top: 20px;
      }
    }
    .default-footer-info {
      @media screen and(max-width:576px) {
        margin-top: 20px;
      }
    }
  }
  &--bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 40px;
    padding-top: 40px;
    border-top: 1px solid rgba(34, 35, 35, 0.1);
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: var(--default-foot-tx-color, #222232);
    a {
      color: var(--default-foot-tx-color, #222232);
      line-height: 24px;
    }
    &__left {
      & > p > a {
        margin: 0 10px 0 0;
      }
      &::v-deep {
        .langs_div_class {
          .langs_select_class {
            width: 120px;
            padding: 3px 0px;
            border: 1px solid #f0f0f0;
            color: black;
          }
        }
      }
    }
    @media screen and (max-width: 576px) {
      &__left {
        width: 100%;
        & > p > a {
          display: block;
          margin: 0 0 10px 0;
        }
        &::v-deep {
          .langs_div_class {
            margin: 10px 0 0 0;
            height: auto;
          }
        }
      }
      .payment_icons {
        width: 100%;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>